export default __webpack_public_path__ + "static/media/Astro_Uranus_White.ce559d12.png";